module.exports = __webpack_public_path__ + "img/baloise-small.849c421.png";